import React, { useState } from 'react';
import {
  Button,
} from '@material-ui/core';

import Dialog from '../../ui/Dialog';
import LoadingOverlay from '../../LoadingOverlay/LoadingOverlay.component';
import { putTransactionCodeFreeGoodApprove } from '../../../services/transaction.service';

const ApproveFreeBox = ({ data }) => {
  const { program_id, transaction_code_id } = data;

  const [state, setState] = useState({
    openConfirmation: false,
    openValidateConfirmation: true,
    modalTitle: 'Approve Free Box',
    errorMessage: null,
    successMessage: 'Free box has been approved successfully!',
    isLoading: false,
    latestMessage: '',
    messageLogId: null,
    submitButtonEnabled: false,
  });

  const handleClose = () => {
    const { openConfirmation } = state;
    setState(prev => ({
      ...prev,
      openConfirmation: false,
      openValidateConfirmation: false,
      errorMessage: null
    }));

    if (openConfirmation) {
      window.location.reload();
    }
  };

  const onValidate = async () => {
    setState(prev => ({ ...prev, isLoading: true }));

    try {
      const { message } = await putTransactionCodeFreeGoodApprove({
        transaction_code_id,
        connect_program_id: program_id,
      });
      
      setState(prev => ({
        ...prev,
        openValidateConfirmation: false,
        successMessage: message
      }));
    } catch (e) {
      setState(prev => ({
        ...prev,
        errorMessage: e.message
      }));
    } finally {
      setState(prev => ({ ...prev, isLoading: false, openValidateConfirmation: false, openConfirmation: true }));
    }
  };

  const {
    openConfirmation,
    modalTitle,
    errorMessage,
    successMessage,
    isLoading,
    openValidateConfirmation
  } = state;

  if (isLoading) return <LoadingOverlay />;

  const formButtons = (
    <>
      <Button onClick={handleClose} variant="contained">
        {openConfirmation ? 'OK' : 'Close'}
      </Button>
      {
        openValidateConfirmation && 
        <Button
          onClick={onValidate}
          variant="contained"
          color="primary"
          disabled={false}
        >
          Approve
        </Button>
      }
    </>
  );

  return (
    <>
      <Dialog
        key="approve-free-box"
        open={openValidateConfirmation}
        title={modalTitle}
        content = {`Are you sure to approve the free box?`}
        children={formButtons}
        onSubmit={onValidate}
        onClose={handleClose}
      />
      <Dialog 
        onSubmit={handleClose}
        key="confirmation"
        open={openConfirmation}
        title='Approve Free Box'
        content={errorMessage || successMessage}
        children={formButtons}
        onClose={handleClose}
      />
      <Button variant="contained" color="primary" onClick={() => {
         setState(prev => ({
          ...prev,
          openValidateConfirmation: true,
        }));
      }} style={{ marginRight: 8 }}>
        Approve
      </Button>
    </>
  );
};

export default ApproveFreeBox;